<template>
	<div>

		<form enctype="multipart/form-data" v-if="!input_xmls.length">
			<div
				class="input-group"
				@dragenter="dragclass='dragclass'"
				@dragleave="dragclass=''"
				@dragend="dragclass=''">
				<div class="custom-file">
					<input
						type="file"
						id="drop_zone"
						class="custom-file-input"
						ref="file"
						@change="get_files"
						multiple>
					<label
						:class="dragclass"
						class="custom-file-label"
						for="file_input">
						<h5 class="headline">Déposez vos xml ici ou Cliquez pour browser</h5>
					</label>
				</div>
			</div>
		</form>

		<v-btn flat color="primary" v-if="input_xmls.length" @click="remove_all()">
			<v-icon left>delete</v-icon>
			Clear All
		</v-btn>

		<v-progress-linear v-if="loading" :indeterminate="true" />

		<v-expansion-panel>
			<v-expansion-panel-content v-for="(xml,i) in input_xmls" :key="'xml' + i" class="background lighten-1">
				<template v-slot:header>
					<div>{{ xml.file }}</div>
				</template>
				<v-card color="background">
					<v-card-text class="pa-2">
						<tree-view :data="xml.content" :options="{maxDepth: 3, rootObjectKey: xml.file}" />
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat color="primary" @click="remove_one(i)">
							<v-icon left>delete</v-icon>
							Clear
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>

		<v-alert type="error" :value="true" v-for="(err,i) in errors" :key="'err' + i">
			{{ err }}
		</v-alert>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

	</div>
</template>

<script>

import xmljs from 'xml-js'
export default {
	name: '',
	props: ['debug', 'wf_data', 'details'],
	data () {
		return {
			dragclass: '',
			loading: false,
			input_xmls: [],
			errors: []
		}
	},
	computed: {
		form () {
			let output = []
			for (var i = 0; i < this.input_xmls.length; i++) {
				// PKG Lagardere
				if (this.wf_data.label === 'Packager Lagardere') {
					output.push({
						isValid: true,
						jobdescriptorID: this.wf_data.descriptor_id,
						parameters: {
							'order_id': this.input_xmls[i].id,
							'order_data': this.input_xmls[i].content,
							'type': this.getPackageType(this.input_xmls[i].content)
						}
					})
				// PAD Lagardere
				} else if (this.wf_data.label === 'PAD Lagardere') {
					output.push({
						isValid: true,
						jobdescriptorID: this.wf_data.descriptor_id,
						parameters: {
							'order_id': this.input_xmls[i].id,
							'order_data': this.input_xmls[i].content,
							'pkg_type': this.getPackageType(this.input_xmls[i].content)
						}
					})
				}
			}
			return output
		}
	},
	methods: {
		remove_one (index) {
			this.input_xmls.splice(index, 1)
			this.$emit('change', this.form)
		},
		remove_all () {
			this.input_xmls = []
			this.$emit('change', this.form)
		},
		getPackageType (orderData) {
			let packageType = []
			let hasSme = false
			let hasVm = false
			if (orderData.commande.hasOwnProperty('video')) packageType.push('mxf')
			this.$commons.deepGet(orderData, 'commande.subtitles.subtitle', []).map(sub => {
				if (sub.mode._attributes.id === 'CC') {
					if (sub.code._attributes.id === 'SME') hasSme = true
					if (sub.code._attributes.id === 'VM') hasVm = true
				}
			})
			if (hasVm) packageType.push('vm')
			if (hasSme) packageType.push('sme')
			return packageType.join('+')
		},
		get_files () {
			console.log('getFiles')
			this.errors = []
			this.input_xmls = []
			this.dragclass = ''
			this.loading = true
			let InputFiles = this.$refs.file.files

			if (InputFiles.length === 0) {
				this.loading = false
				return
			}

			for (let i = 0; i < InputFiles.length; i++) {
				let fileName = InputFiles[i].name
				let fileExt = fileName.substring(fileName.lastIndexOf('.'), fileName.length)
				if (fileExt.toLowerCase() !== '.xml') {
					this.loading = false
					return
				}
			}

			let that = this
			async function batch (filesList) {
				for (let file of filesList) {
					try {
						let result = await that.fileAnalyzer(file)
						that.input_xmls.push(result)
					} catch (error) {
						throw error
					}
				}
			}

			batch(InputFiles)
				.then(result => {
					this.loading = false
					this.$emit('change', this.form)
				})
				.catch(error => {
					this.input_xmls = []
					this.errors.push(error.stack)
					this.loading = false
					this.$emit('change', this.form)
				})
		},

		fileAnalyzer (file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader()
				reader.onloadend = e => {
					try {
						let eztJson = xmljs.xml2js(reader.result, {compact: true, spaces: 4})
						if (eztJson.commande.audios.hasOwnProperty('audio')) {
							if (eztJson.commande.audios.audio.length === undefined) {
								eztJson.commande.audios.audio = [eztJson.commande.audios.audio]
							}
						}
						if (eztJson.commande.subtitles.hasOwnProperty('subtitle')) {
							if (eztJson.commande.subtitles.subtitle.length === undefined) {
								eztJson.commande.subtitles.subtitle = [eztJson.commande.subtitles.subtitle]
							}
						}
						let output = {
							file: file.name,
							id: eztJson.commande._attributes.id,
							content: eztJson
						}
						resolve(output)
					} catch (error) {
						reject(new Error(`Getting data from ${file.name}: ${error.message}`))
					}
				}
				reader.readAsText(file)
			})
		}
	},
	mounted () {
		if (!this.details) return
		if (Object.keys(this.details).length === 0) return
		let content = null
		let id = null
		if (this.wf_data.label === 'Packager Lagardere') {
			content = this.details['order_data'] || null
			id = this.details['order_id'] || null
		} else if (this.wf_data.label === 'PAD Lagardere') {
			content = this.details['order_data'] || null
			id = this.details['order_id'] || null
		}
		if (content && id) {
			this.input_xmls.push({
				file: id + '.xml',
				id: id,
				content: content
			})
			this.$emit('change', this.form)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

.dragclass
	background-color: var(--v-primary-base) !important
	border: 1px solid var(--v-primary-base) !important
	color: var(--v-background-base) !important

.custom-file-label
.custom-file-input
.custom-file
	height: 10rem
	cursor: pointer

.custom-file-label
	text-align: center
	color: var(--v-primary-base)
	background-color: var(--v-background-lighten1)
	border: 1px dashed var(--v-primary-base)
	padding-top: 3.5rem
	height: 10rem
	&:after
		visibility: hidden
>>>.v-expansion-panel__header
	padding: 0 1em
	border-bottom: 1px solid var(--v-background-base)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_lagardere.vue